export const BEHAVIOR_ROUTE = 'behavior';
export const BEHAVIOR_CONFIG_NAME = 'behavior';
export const BEHAVIOR_FORM_NAME = `${BEHAVIOR_CONFIG_NAME}Form`;
